import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import LogoImg from '../assets/images/v2/tag-logo.svg';
import { AccountActions } from '../actions';
import { LoginForm } from '../components/account';
import { AppConfig } from '../config';

const Login = (
  { token, error, loading, loginAction, googleLoginAction, facebookLoginAction, resetAction },
  context
) => {
  const StyledLogo = styled.img`
    width: 100%;
    max-width: 400px;
    padding: 0px 20px;
  `;

  const onSubmitHandler = params => {
    loginAction(params.email, params.password);
  };

  useEffect(() => {
    // use effect with empty array as dependency simulates componentDidMount lifecycle method
    // in our case we dont need to do anything
    return () => {
      // return function of useEffect replaces componentWillUnmount lifecycle method
      resetAction();
    };
  }, [resetAction]);

  // if token exists user is already logged in, lets redirect back to dashboard
  if (token && token !== '') {
    return <Redirect to="/dashboard" />;
  }
  const onGoogleLoginSuccessHandler = response => {
    googleLoginAction(response.tokenObj);
  };

  const onGoogleLoginFailureHandler = e => {
    console.log(e);
  };

  const onFacebookCallbackHandler = response => {
    const token = {
      access_token: response.accessToken,
    };
    facebookLoginAction(token);
  };

  const onFacebookLoginFailureHandler = e => {
    console.log(e);
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-center">
        <StyledLogo style={{ width: 150, height: 50 }} src={LogoImg} alt="logo" />
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-5 border-md-1">
          <div className="card p-4" style={{ backgroundColor: 'transparent', border: 0 }}>
            <div className="card-body">
              {/* <h1 className="text-center mb-3">{context.t('PAGE.LOGIN.HEADING')}</h1> */}
              {/* <p className="text-muted text-center mb-5">{context.t('PAGE.LOGIN.SUBHEADING')}</p> */}
              {error && (
                <div className="alert alert-danger alert-dismissible fade show">
                  {context.t(error)}
                </div>
              )}
              <LoginForm loading={loading} onSubmit={onSubmitHandler} />
              <div style={{ display: 'none' }}>
                <GoogleLogin
                  className="btn-google btn-brand w-100 my-2"
                  buttonText={context.t('APP.GOOGLE-LOGIN')}
                  clientId={AppConfig.GOOGLE_CLIENT_ID}
                  onSuccess={onGoogleLoginSuccessHandler}
                  onFailure={onGoogleLoginFailureHandler}
                />
                <FacebookLogin
                  cssClass="btn-facebook btn-brand w-100"
                  appId={AppConfig.FACEBOOK_CLIENT_ID}
                  autoLoad={false}
                  fields="email,first_name,last_name,link,about,id,name,picture,location"
                  onFailure={onFacebookLoginFailureHandler}
                  callback={onFacebookCallbackHandler}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Login.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  token: state.account.token,
  error: state.account.error,
  loading: state.account.loading,
});

const mapDispatchToProps = dispatch => ({
  loginAction: (email, password) => {
    dispatch(AccountActions.login(email, password));
  },
  googleLoginAction: token => {
    dispatch(AccountActions.googleLogin(token));
  },
  facebookLoginAction: token => {
    dispatch(AccountActions.facebookLogin(token));
  },
  resetAction: () => {
    dispatch(AccountActions.reset());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
